<template>
    <div>
        <product
            v-for="item in products"
            :key="item.product_id"
            :data="item"
            :increase="increase"
            :decrease="decrease"></product>
    </div>
</template>

<script>
    import cartMixin from '../mixins/cartMixin';
    import * as Actions from '../store/action-types';

    export default {
        props: {
            data: {
                type: Array,
                required: true
            }
        },

        mixins: [cartMixin],

        mounted() {
            this.$store.dispatch(Actions.addTodayProducts, {products: this.data});
        },

        computed: {
            products() {
                return this.$store.getters.todayProducts;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/TodayTicket.vue